import {
  // Assessment as AssessmentIcon,
  Dashboard as DashboardIcon,
  EmojiPeople as EmojiPeopleIcon,
  Refresh as RefreshIcon,
  SupervisorAccount as SupervisorAccountIcon,
  SupervisedUserCircle as SupervisedUserCircleIcon,
  School, Person,
} from '@material-ui/icons';
// third-party
import paths from 'paths';
import { ccTypes } from 'store/constant';
import ListAltIcon from '@mui/icons-material/ListAlt';
// constant

// -----------------------|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||-----------------------//

// eslint-disable-next-line import/prefer-default-export
export default {
  id: 'menu-other',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: paths.dashboard.reverse(),
      icon: DashboardIcon,
      breadcrumbs: false,
      ccTypesAllowed: [ccTypes.internal, ccTypes.viewer],
    },
    {
      id: 'rotations',
      title: 'Rotations',
      type: 'item',
      url: paths.rotations.reverse(),
      icon: RefreshIcon,
      breadcrumbs: false,
      ccTypesAllowed: [ccTypes.internal, ccTypes.viewer],
    },
    {
      id: 'students',
      title: 'Students',
      type: 'item',
      url: paths.students.reverse(),
      icon: SupervisorAccountIcon,
      breadcrumbs: false,
      ccTypesAllowed: [ccTypes.internal, ccTypes.viewer],
    },
    {
      id: 'preceptors',
      title: 'Preceptors',
      type: 'item',
      url: paths.preceptors.reverse(),
      icon: SupervisedUserCircleIcon,
      breadcrumbs: false,
      ccTypesAllowed: [ccTypes.internal, ccTypes.viewer],
    },
    {
      id: 'clinic-coordinator',
      title: 'Clinic Coordinators',
      type: 'item',
      isSuperuser: true,
      url: paths.clinicCoordinators.reverse(),
      icon: Person,
      breadcrumbs: false,
      ccTypesAllowed: [ccTypes.internal, ccTypes.viewer],
    },
    {
      id: 'requests',
      title: 'Search Requests',
      type: 'item',
      url: paths.requests.reverse(),
      icon: EmojiPeopleIcon,
      breadcrumbs: false,
      ccTypesAllowed: [ccTypes.internal, ccTypes.viewer],
    },
    {
      id: 'waitlist',
      title: 'Waitlist',
      type: 'item',
      url: paths.whitelists.reverse(),
      icon: ListAltIcon,
      breadcrumbs: false,
      ccTypesAllowed: [ccTypes.internal, ccTypes.viewer],
    },
    // {
    //   id: 'school',
    //   title: 'Schools',
    //   type: 'item',
    //   url: paths.school.reverse(),
    //   icon: School,
    //   breadcrumbs: false,
    //   ccTypesAllowed: [ccTypes.internal, ccTypes.viewer],
    // },
    /* {
      id: 'reports',
      title: 'Reports',
      type: 'item',
      url: paths.reports.reverse(),
      icon: AssessmentIcon,
      breadcrumbs: false,
    }, */
    {
      id: 'rotations',
      title: 'Rotations',
      type: 'item',
      url: paths.rotationsCCSchool.reverse(),
      icon: RefreshIcon,
      breadcrumbs: false,
      ccTypesAllowed: [ccTypes.external],
    },
    {
      id: 'students',
      title: 'Students',
      type: 'item',
      url: paths.studentsCCSchool.reverse(),
      icon: SupervisorAccountIcon,
      breadcrumbs: false,
      ccTypesAllowed: [ccTypes.external],
    },
    {
      id: 'preceptors',
      title: 'Preceptors',
      type: 'item',
      url: paths.preceptorsCCSchool.reverse(),
      icon: SupervisedUserCircleIcon,
      breadcrumbs: false,
      ccTypesAllowed: [ccTypes.external],
    },
    {
      id: 'school-managements',
      title: 'School Management',
      type: 'collapse',
      ccTypesAllowed: [ccTypes.internal, ccTypes.viewer],
      children: [
        {
          id: 'school',
          title: 'Schools',
          type: 'item',
          url: paths.school.reverse(),
          icon: School,
          breadcrumbs: false,
          ccTypesAllowed: [ccTypes.external],
        },
        {
          id: '/school-data/students/',
          title: 'Students',
          type: 'item',
          url: paths.studentsSchool.reverse(),
          icon: SupervisorAccountIcon,
          breadcrumbs: false,
          ccTypesAllowed: [ccTypes.external],
        },
        {
          id: 'rotations-data',
          title: 'Rotations',
          type: 'item',
          url: paths.rotationsSchool.reverse(),
          icon: RefreshIcon,
          breadcrumbs: false,
          ccTypesAllowed: [ccTypes.external],
        },
      ],
    },
    {
      id: 'archive',
      title: 'Archive',
      type: 'collapse',
      ccTypesAllowed: [ccTypes.internal, ccTypes.viewer],
      children: [
        {
          id: '/archive/students/',
          title: 'Students',
          type: 'item',
          url: paths.studentsArchive.reverse(),
          icon: SupervisorAccountIcon,
          breadcrumbs: false,
          ccTypesAllowed: [ccTypes.internal, ccTypes.viewer],
        },
        {
          id: '/archive/preceptors/',
          title: 'Preceptors',
          type: 'item',
          url: paths.preceptorsArchive.reverse(),
          icon: SupervisedUserCircleIcon,
          breadcrumbs: false,
          ccTypesAllowed: [ccTypes.internal, ccTypes.viewer],
        },
        {
          id: '/archive/rotations/',
          title: 'Rotations',
          type: 'item',
          url: paths.rotationsArchive.reverse(),
          icon: RefreshIcon,
          breadcrumbs: false,
          ccTypesAllowed: [ccTypes.internal, ccTypes.viewer],
        },
      ],
    },
    {
      id: 'school',
      title: 'Schools',
      type: 'item',
      url: paths.schoolCCSchool.reverse(),
      icon: School,
      breadcrumbs: false,
      ccTypesAllowed: [ccTypes.external],
    },
  ],
};
